/**
 * Force a hard refresh: clears Cache Storage, unregisters service workers,
 * drops app-level localStorage caches, then reloads with a cache-buster.
 */
export async function hardRefresh() {
  try {
    if ("caches" in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
  } catch {}
  try {
    if ("serviceWorker" in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    }
  } catch {}
  try {
    Object.keys(localStorage)
      .filter((k) => /cache|active-rv-types|manifest|inventory/i.test(k))
      .forEach((k) => localStorage.removeItem(k));
  } catch {}
  const url = new URL(window.location.href);
  url.searchParams.set("_r", Date.now().toString());
  window.location.replace(url.toString());
}